/**
 * Constantes utilizadas no sistema de horários
 */

export const SECCOES = ['Café', 'Loja Avelal', 'Loja Sátão'];

export const TIPOS_DIA = [
  { value: 'normal', label: 'Normal', color: 'bg-pink-100 border-pink-300 text-pink-900' },
  { value: 'reuniao', label: 'Reunião', color: 'bg-purple-200 border-purple-400 text-purple-900' },
  { value: 'gestao', label: 'Gestão', color: 'bg-orange-200 border-orange-400 text-orange-900' },
  { value: 'apoio', label: 'Apoio', color: 'bg-indigo-200 border-indigo-400 text-indigo-900' },
  { value: 'integracao', label: 'Integração', color: 'bg-teal-200 border-teal-400 text-teal-900' },
  { value: 'folga', label: 'Folga', color: 'bg-yellow-300 border-yellow-500 text-yellow-900 font-bold' },
  { value: 'ferias', label: 'Férias', color: 'bg-green-200 border-green-400 text-green-900' },
  { value: 'falta', label: 'Falta', color: 'bg-red-200 border-red-400 text-red-900' },
  { value: 'troca', label: '🔄 Troca', color: 'bg-gradient-to-r from-orange-300 to-red-300 border-orange-500 text-orange-900 font-bold' },
  { value: 'baixa', label: 'Baixa', color: 'bg-yellow-200 border-yellow-400 text-yellow-900' }
];

// Feriados portugueses por ano (inclui feriado municipal 20 de Agosto)
export const FERIADOS_PT = {
  2024: [
    '2024-01-01', '2024-03-29', '2024-03-31', '2024-04-25', '2024-05-01',
    '2024-05-30', '2024-06-10', '2024-08-15', '2024-08-20', '2024-10-05', '2024-11-01',
    '2024-12-01', '2024-12-08', '2024-12-25'
  ],
  2025: [
    '2025-01-01', '2025-04-18', '2025-04-20', '2025-04-25', '2025-05-01',
    '2025-06-10', '2025-06-19', '2025-08-15', '2025-08-20', '2025-10-05', '2025-11-01',
    '2025-12-01', '2025-12-08', '2025-12-25'
  ],
  2026: [
    '2026-01-01', '2026-04-03', '2026-04-05', '2026-04-25', '2026-05-01',
    '2026-06-04', '2026-06-10', '2026-08-15', '2026-08-20', '2026-10-05', '2026-11-01',
    '2026-12-01', '2026-12-08', '2026-12-25'
  ],
  2027: [
    '2027-01-01', '2027-03-26', '2027-03-28', '2027-04-25', '2027-05-01',
    '2027-05-27', '2027-06-10', '2027-08-15', '2027-08-20', '2027-10-05', '2027-11-01',
    '2027-12-01', '2027-12-08', '2027-12-25'
  ]
};

export const TEMPLATES_TURNOS = [
  // Tipos especiais
  { id: 'folga', nome: '🏖️ Folga', horario: null, tipo: 'folga' },
  { id: 'folga_compensacao', nome: '🏖️ Folga Comp. (8h)', horario: null, tipo: 'folga_compensacao' },
  { id: 'ferias', nome: '✈️ Férias', horario: null, tipo: 'ferias' },
  { id: 'falta', nome: '❌ Falta', horario: null, tipo: 'falta' },
  { id: 'baixa', nome: '⚠️ Baixa', horario: null, tipo: 'baixa' },
  { id: 'gestao', nome: '📋 Gestão (horas manuais ou 8h)', horario: null, tipo: 'gestao' },
  // Tipos com horas manuais (campo livre tipo "REUNIÃO 20h-21h")
  { id: 'reuniao', nome: '👥 Reunião (horas manuais)', horario: null, tipo: 'reuniao' },
  { id: 'apoio', nome: '🤝 Apoio (horas manuais)', horario: null, tipo: 'apoio' },
  { id: 'integracao', nome: '🎓 Integração (horas manuais)', horario: null, tipo: 'integracao' },
];

export const CABECALHO_PADRAO = 'ENTIDADE EMPREGADORA: MOTIVOS À JUSTA, Lda     SEDE E LOCAL DE TRABALHO: Avenida Comendador Elísio F. Afonso nº 36 - AVELAL -SÁTÃO     CAE: 92000 - Lotarias e outros jogos de aposta; 47112 - Comércio a retalho em outros estabelecimentos não especializados(…)   56301 - Cafés     IRCT / BTE:CCT entre a APHORT e a FESAHT / BTE Nº 23 de 22/06/2018 HORÁRIO DE FUNCIONAMENTO 7h-19h/21h - HORÁRIO DO PESSOAL - Horário Flutuante/IHT*(Isenção de Horário Total) GERENTE: Agostinho Oliveira; IHT*: Marta Gabriela O. Monteiro; EMPREGADO DE BALCÃO DE 3ª:  Ângelo M. A. Pinto;  David J. Jesus F.; Filipe Pina; Patrícia Isabel Rodrigues Morgado; Ricardo Luís Almeida Santos; Adriana Patricia Monteiro; Matilde Nunes Costa;Laetitia Correia Monteiro';
